import { breakpointSizePx, BreakpointSize } from '@jbhi-fi/lanyard-ui/themes';

const breakpointKeys = Object.keys(breakpointSizePx).reverse() as Array<BreakpointSize>;

export const getBreakpointValue = (width: number): BreakpointSize => {
  return breakpointKeys.find(key => width >= breakpointSizePx[key]) ?? 'xxl';
};
